export interface MyTeamsFilters {
  rank?: string[];
  fibc?: string;
  period?: string;
  frontlineOnly?: boolean;
  closeToNextRank?: boolean;
  cabEarned?: boolean;
  aabEarned?: boolean;
  fqvMin?: number;
  fqvMax?: number;
  newClientsAbove?: number;
  newClientsBelow?: number;
  qualifiedClientsAbove?: number;
  qualifiedClientsBelow?: number;
  newCoachesAbove?: number;
  newCoachesBelow?: number;
  periodDefaultValue?: string;
  frontlineAction?: 'Frontline_add' | 'Frontline_remove';
}

export const DEFAULT_FIBC = 'Any';
export const getDefaultFilters = (defaultNewCoachesKey: string) => ({
  frontlineOnly: false,
  rank: [],
  period: defaultNewCoachesKey,
  fibc: DEFAULT_FIBC,
  fqvMin: undefined,
  fqvMax: undefined,
  newClientsAbove: undefined,
  newClientsBelow: undefined,
  qualifiedClientsAbove: undefined,
  qualifiedClientsBelow: undefined,
  newCoachesAbove: undefined,
  newCoachesBelow: undefined,
  cabEarned: false,
  aabEarned: false,
  closeToNextRank: false,
});

export const isDefaultFilters = (
  filters: MyTeamsFilters,
  defaultNewCoachesKey: string,
  defaultNewCoachesValue: string,
) => {
  return (
    filters.frontlineOnly === false &&
    (filters.rank?.length || 0) === 0 &&
    (filters.fibc === 'Any' || filters.fibc === 'any') &&
    (filters.period === defaultNewCoachesKey ||
      filters.period === defaultNewCoachesValue) &&
    filters.fqvMin === undefined &&
    filters.fqvMax === undefined &&
    filters.newClientsAbove === undefined &&
    filters.newClientsBelow === undefined &&
    filters.qualifiedClientsAbove === undefined &&
    filters.qualifiedClientsBelow === undefined &&
    filters.newCoachesAbove === undefined &&
    filters.newCoachesBelow === undefined &&
    !filters.cabEarned &&
    !filters.aabEarned &&
    filters.closeToNextRank === false
  );
};

export const hasFiltersApplied = (
  filters: MyTeamsFilters,
  defaultNewCoachesKey: string,
) => {
  return (
    (filters.rank?.length || 0) > 0 ||
    (filters.fibc &&
      filters.fibc.toLowerCase() !== DEFAULT_FIBC.toLowerCase()) ||
    (filters.period && filters.period !== defaultNewCoachesKey) ||
    filters.cabEarned ||
    filters.aabEarned ||
    filters.frontlineOnly === true ||
    filters.closeToNextRank === true ||
    filters.fqvMin !== undefined ||
    filters.fqvMax !== undefined ||
    filters.newClientsAbove !== undefined ||
    filters.newClientsBelow !== undefined ||
    filters.qualifiedClientsAbove !== undefined ||
    filters.qualifiedClientsBelow !== undefined ||
    filters.newCoachesAbove !== undefined ||
    filters.newCoachesBelow !== undefined
  );
};

export const mapUIFiltersToRedux = (
  filtersDraft: any,
  defaultNewCoachesKey: string,
): MyTeamsFilters => {
  const newCoachesFilter = filtersDraft?.newCoachesOptions?.find(
    (item: any) => item.selected,
  );

  const rankOptionsFilter =
    filtersDraft?.rankOptions?.filter((item: any) => item.selected) || [];

  const fibcFilter = filtersDraft?.fibcOptions?.find(
    (item: any) => item.selected,
  );

  const bonusFilters =
    filtersDraft?.bonusOptions?.filter((item: any) => item.selected) || [];

  return {
    rank: rankOptionsFilter.map((r: any) => r.id),

    fibc: fibcFilter?.id || DEFAULT_FIBC,

    period: newCoachesFilter?.id || defaultNewCoachesKey,

    cabEarned: bonusFilters.some((b: any) => b.id === 'cabEarnedLastPeriod'),

    aabEarned: bonusFilters.some((b: any) => b.id === 'aabEarnedLastPeriod'),

    frontlineOnly: filtersDraft?.frontlineOnly ?? false,

    closeToNextRank: filtersDraft?.closeToNextRank ?? false,

    fqvMin: filtersDraft?.fqvWithoutFilter?.min,
    fqvMax: filtersDraft?.fqvWithoutFilter?.max,

    newClientsAbove: filtersDraft?.newClientsWithoutFilter?.min,
    newClientsBelow: filtersDraft?.newClientsWithoutFilter?.max,

    qualifiedClientsAbove: filtersDraft?.qualifiedClientsWithoutFilter?.min,

    qualifiedClientsBelow: filtersDraft?.qualifiedClientsWithoutFilter?.max,

    newCoachesAbove: filtersDraft?.newCoachesSponsoredWithoutFilter?.min,

    newCoachesBelow: filtersDraft?.newCoachesSponsoredWithoutFilter?.max,
  };
};
